const theme = {
    colors: {
      primary: '#8257E6',
      background: '#FFFFFF',
      shape: `#F2F2FA`,
      title: `#2C2929`,
      text: `#2C2929`,
      components: {
        blockquote: {
          background: `#282a36`,
          text: `#FFFFFF`,
        },
      },
    },
  };

  export default theme
  